module.exports = __webpack_public_path__ + "static/media/font_medium.b44628eb.woff";